import React, { useContext, useEffect } from "react";
import FilterPopup from "../FilterPopup";
import { Button } from "semantic-ui-react";
import moment from "moment";
import { FilterContext } from "../FilterContext";
import { initialQuarterFilter, QuarterFilterType } from "./FilterTypes/QuarterFilterType";
import { PerQuarter } from "../periodfilter/periodfiltersubperiod";

const QuarterFilter = () => {
  const title = RESX.DateTime.Quarter;

  const { register, getValue, setInitialValue, setValue } = useContext(FilterContext);
  register("quarter", {
    getTitle: () => title,
    renderSelection: (filter) => <>
      {formatDate(filter.quarter)}
    </>,
    hasValue: (filter) => filter.quarter != null,
    reset: () => initialQuarterFilter,
    areEqual: (a, b) => {
      if (a?.quarter == null && b?.quarter == null) return true;
      if (a?.quarter == null || b?.quarter == null) return false;
      return a?.quarter.startOf("quarter").isSame(b?.quarter.startOf("quarter"));
    }
  });
  useEffect(() => {
    setInitialValue("quarter", initialQuarterFilter);
  }, []);

  const [popupOpen, setPopupOpen] = React.useState<boolean>(false);
  const [filterVal, setFilterVal] = React.useState<QuarterFilterType>(initialQuarterFilter);
  const [apply, setApply] = React.useState<boolean>(false);

  const onPopupClose = () => {
    setPopupOpen(false);
  };

  const onPopupOpen = () => {
    const value = getValue("quarter");
    setFilterVal(value);
    setPopupOpen(true);
  };

  React.useEffect(() => {
    if (apply) {
      onApply();
      setApply(false);
      setPopupOpen(false);
    }
  }, [apply]);

  const onApply = (e?) => {
    e?.preventDefault();

    setValue("quarter", filterVal);
    setPopupOpen(false);
  };

  return <div>
    <FilterPopup
      filterButtonLabel={title}
      content={<form onSubmit={(e) => { e.preventDefault(); setApply(true); }}>
        <div className="margin-bottom">
          <PerQuarter
            initialStart={filterVal.quarter}
            initialEnd={filterVal.quarter}
            onChange={m => setFilterVal({ quarter: m })}
          />
        </div>
        <Button fluid primary>
          {RESX.SelectionManager.Apply}
        </Button>
      </form>}
      width={400}
      open={popupOpen}
      onClose={onPopupClose}
      onOpen={onPopupOpen}
    />
  </div>;
};

export default QuarterFilter;

const formatDate = (quarter: moment.Moment): string => {
  let quarterText = "";
  switch (quarter.quarter()) {
    case 1:
      quarterText = RESX.DateTime.Quarter1;
      break;
    case 2:
      quarterText = RESX.DateTime.Quarter2;
      break;
    case 3:
      quarterText = RESX.DateTime.Quarter3;
      break;
    case 4:
      quarterText = RESX.DateTime.Quarter4;
      break;
  }

  return `${quarterText} ${quarter.format("YYYY")}`;
}
